import { QueryPageParams } from "../../../../redux/RTKQuery/api";

export interface NotActivatedLicenseKey {
    id: number;
    key: string;
    orderId: string;
    licenseType: number; // 0 = free, 1 = paid (предположение)
    productTitle: string;
    lastRebillDate: string;
    nextRebillDate: string | null;
}

export interface FetchNotActivatedLicenseKeys {
    totalCount: number;
    filteredCount: number;
    items: NotActivatedLicenseKey[];
}

export enum LicenseType {
    Lifetime = 0,
    Subscription = 1,
}

export interface LicenseKeysNotActivatedQueryParams
    extends Partial<QueryPageParams> {
    productId?: number;
    licenseKey?: string;
    endDate?: number;
    startDate?: number;
    orderId?: string;
}

export type NotActivatedLicenseKeyRow = Pick<
    NotActivatedLicenseKey,
    | "lastRebillDate"
    | "orderId"
    | "key"
    | "licenseType"
    | "productTitle"
    | "nextRebillDate"
>;
